import produce from "immer";
import * as QCAssaySummConstant from './QCAssaySummConstants';

const assign = Object.assign || require('object.assign');

export default function QCAssaySummReducer(state = {}, action) {

    switch (action.type) {

        case  QCAssaySummConstant.QC_ASSAY_STATE_ADD: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isQCAssaySummFetched: false,
                    isQCAssaySummFetching: false,
                    isQCAssaySummFailed: false,
                    qcAssaySummData: []
                    
                }
            });
            return assign({}, state, newState);
        }

        case QCAssaySummConstant.QC_ASSAY_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }

        case QCAssaySummConstant.QC_ASSAY_SUMMARY_DATA_FETCHING:{
           
            const newState = produce(state, (draft) => {
                
                draft[action.payload] = {
                    ...draft[action.payload],
                    isQCAssaySummFetched: false,
                    isQCAssaySummFetching: true,
                    isQCAssaySummFailed: false,
                    qcAssaySummData: []
                }
                
            });
            return assign({}, state,newState);
        }
        
        case QCAssaySummConstant.QC_ASSAY_SUMMARY_DATA_FETCHED:{
            
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    isQCAssaySummFetched: true,
                    isQCAssaySummFetching: false,
                    isQCAssaySummFailed: false,
                    qcAssaySummData: action.payload.newState.result
                }
            });

            return assign({}, state,newState);
        }

        case QCAssaySummConstant.QC_ASSAY_SUMMARY_DATA_FETCHING_FAILED:{
           const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isQCAssaySummFetched: false,
                    isQCAssaySummFetching: false,
                    isQCAssaySummFailed: true,
                    qcAssaySummData: []
                }
            });

            return assign({}, state,newState);
        }
        
        default:
        return state;

    }

}
